import { Component } from "react"
import Popup from "../common/Popup"
import { showToast, INPUT_VIEW_DIRECTION,TOAST_TYPE, DKButton,INPUT_TYPE, showLoader, removeLoader, DKIcons, DKLabel, DKIcon, DKSpinner, DKTooltipWrapper, DKInput, Toggle } from "deskera-ui-library";
import PayrollService from "../../services/PayrollService";
import { empList } from "./AttendanceSettingService";
import Utility from "../../utility/Utility";
import i18next from "i18next";
export default class EmployeePopup extends Component {
    options = []
    canValidate = false
    constructor(props) {
        super(props)
        this.state = {
            isApplicableToAll:this.props.data?.rowData?.isApplicableToAll,
            name:[]
        }
        if((empList && empList.length!=0)) {
            this.options = empList;
            this.setOptionToField()
        } else {
            this.getUsers()
        }
    }
    componentDidMount() {
        this.setState({
            ...this.state
        })
    }
    setOptionToField(){
        let ind = this.props.data?.rowData?.employees?.map(e=>{return this.options.findIndex(o=>o.iamUserId==e)})
        this.state.name = (ind && ind.length != 0) ? ind.filter(i=> i!==-1):[]
    }
    onClose() {
        if (this.props.onClose) {
            this.props.onClose()
        }
    }
    updateState() {
        this.setState({
            ...this.state
        })
    }
    onChange(value) {
        this.setState({
            name:value
        })
    }
    save() {
        if(this.state.isApplicableToAll) {
            if (this.props.onClose) {
                this.props.onClose({
                    isApplicableToAll:this.state.isApplicableToAll
                })
            }
            this.canValidate = false;
        } else {
            if(!Utility.isEmpty(this.state.name)) {
                if (this.props.onClose) {
                    this.props.onClose({
                        isApplicableToAll:this.state.isApplicableToAll ? true:false,
                        employeeName: this.state.name.map(i=>this.options[i])
                    })
                }
            } else {
                this.canValidate = true;
                this.updateState()
            }
            
        }
    }
    getUsers() {

        PayrollService.getUsersList().then((res) => {

            if (res && res.users) {
                
               this.options =  res.users;
               this.setOptionToField()
               this.updateState()
               
            }
        });
    }
    getEmployeeField() {
        return (
            <div className="parent-width">
                <DKInput
                    className={"p-v-l "}
                    
                    title={i18next.t("EMPLOYEE")}
                    placeholder={i18next.t("EMPLOYEE")}
                    value={this.state.name}
                    options={this.options}
                    type={INPUT_TYPE.DROPDOWN}
                    labelClassName=" text-align-left "
                    canValidate={this.canValidate}
                    onChange={(value) => {
                        this.onChange(value);
                        // this.updateState()
                    }}
                    displayKey="name"
                    
                    formatter={(obj) => {
                        /** How to render a selected option in case of object **/
                        return obj?.name;
                    }}
                    dropdownConfig={{
                        className: "",
                        style: {},
                        data: this.options,
                        multiSelect: true,
                        selectedIndexes: [],
                        allowSearch:
                        this.options && this.options.length > 6 ? true : false,
                        searchableKey: "name",
                        renderer: (index, obj) => {
                            /** How to render value in Dropdown in case of object **/
                            return <DKLabel text={`${obj?.name}`} />;
                        },
                        onSelect: (index, obj) => {

                        },
                    }}
                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                    required={true}
                />
            </div>
        )
    }
    render() {
        return (
            <Popup popupClass={"popup-overflow"}>
                <div className="row justify-content-between">
                    <DKLabel className="fw-m fs-l" text={i18next.t("SELECT_EMPLOYEE")} />
                    <div className="d-flex">
                        <DKButton title={i18next.t("SAVE")} className="bg-app  text-white " onClick={() => this.save()}/>
                        <DKButton title={i18next.t("CANCEL")} className=" border-m bg-gray1  ml-m" onClick={() => this.onClose()} />
                    </div>

                </div>
                <div className="row mt-l">
                        <Toggle
                            className="border-n"
                            isOn={this.state.isApplicableToAll}
                            onChange={() => {
                                this.setState({
                                    isApplicableToAll: !this.state.isApplicableToAll
                                })
                            }}
                        />
                        <DKLabel className="pl-l" text={i18next.t("APPLICABLE_TO_ALL_EMP")} />
                        
                    </div>
                    {
                        !this.state.isApplicableToAll && this.getEmployeeField()
                    }
            </Popup>
        )
    }
}
